import moment from 'moment'
import { PricingResponse } from '../models/http'
import { PricingSchema } from '../models/price'
import { mockDiscountPlanUser } from './user-mock'
import { DiscountSchema } from 'models/discount'
import { mockTenantsRef } from 'services/data-provider/mock'
import { mockMultiFamily1Chargers } from './charger-mock'

export const mockPricingSchema = [
  {
    id: 48,
    name: 'Tenant Pricing',
    tenantId: 4,
    state: 'active',
    taxSource: 'taxjar',
    priceType: 'Hour',
    flatFeeCents: 0,
    demandResponseFeeCents: 0,
    guestFeeCents: 50,
    commissionPercent: 10.0,
    paymentLimitCents: 10000,
    timeOfDayPriceWeekday: [
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
    ],
    timeOfDayPriceWeekend: [
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
    ],
    enableAddtionalServiceFee: false,
    enablePricingCurtailment: false,
    loiteringType: 'time_based',
    loiteringTimeLimitMinutes: 2,
    loiteringGracePeriodMinutes: 0,
    timeOfDayLoiteringWeekday: [
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
    ],
    timeOfDayLoiteringWeekend: [
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
    ],
    deprecatedAt: null,
    createdAt: '2023-11-23T20:54:12Z',
    updatedAt: '2024-06-19T19:26:44Z',
    personId: 'OlJP4cxDPc6u_F8-RVrgiQ',
    loiteringMaximumCents: 10000,
    appliedListings: mockMultiFamily1Chargers.listings.slice(0, 2).map(({ id, title }) => ({
      listingId: id,
      listingTitle: title,
    })),
  },
  {
    id: 54,
    name: 'Single Pricing AB03 ab5055',
    tenantId: 4,
    state: 'active',
    taxSource: 'taxjar',
    priceType: 'Hour',
    flatFeeCents: 0,
    demandResponseFeeCents: 0,
    guestFeeCents: 50,
    commissionPercent: 10.0,
    paymentLimitCents: 10000,
    timeOfDayPriceWeekday: [
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
    ],
    timeOfDayPriceWeekend: [
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
      1000,
    ],
    enableAddtionalServiceFee: false,
    enablePricingCurtailment: false,
    loiteringType: 'time_based',
    loiteringTimeLimitMinutes: 2,
    loiteringGracePeriodMinutes: 0,
    timeOfDayLoiteringWeekday: [
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
    ],
    timeOfDayLoiteringWeekend: [
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
      2000.0,
    ],
    deprecatedAt: null,
    createdAt: '2023-11-23T20:54:12Z',
    updatedAt: '2024-06-19T19:26:45Z',
    personId: 'OlJP4cxDPc6u_F8-RVrgiQ',
    loiteringMaximumCents: 10000,
    appliedListings: mockMultiFamily1Chargers.listings.slice(2, 3).map(({ id, title }) => ({
      listingId: id,
      listingTitle: title,
    })),
  },
  {
    id: 2,
    name: 'Test',
    tenantId: Number(mockTenantsRef[1].id),
    state: 'active',
    priceType: 'Hour',
    flatFeeCents: 0,
    demandResponseFeeCents: 0,
    guestFeeCents: 50,
    commissionPercent: 10.0,
    paymentLimitCents: 0,
    timeOfDayPriceWeekday: Array(48).fill(100),
    timeOfDayPriceWeekend: Array(48).fill(100),
    enableAddtionalServiceFee: false,
    enablePricingCurtailment: false,
    loiteringType: 'none',
    loiteringTimeLimitMinutes: 0,
    loiteringGracePeriodMinutes: 0,
    timeOfDayLoiteringWeekday: Array(48).fill(0),
    timeOfDayLoiteringWeekend: Array(48).fill(0),
    loiteringMaximumCents: 10000,
    appliedListings: mockMultiFamily1Chargers.listings.slice(3).map(({ id, title }) => ({
      listingId: id,
      listingTitle: title,
    })),
  },
] as PricingSchema[]

export const mockPricingSchemaResp = (page: number) => {
  return {
    data: mockPricingSchema,
    pagination: {
      currentPage: page || 0,
      perPage: 6,
      totalEntries: mockPricingSchema.length,
    },
  } as PricingResponse
}

export const mockPricingSchemaNamesResp = () => {
  return ['test', 'testing']
}

export const mockDiscounts = [
  {
    id: 517,
    name: 'Local Loitering Discount 4#5 b4e849',
    promoCode: 'lpc_4#5_6af5a0',
    tenantId: Number(mockTenantsRef[3].id),
    usageStatus: 'active',
    discountPeriodWeekday: Array(48).fill(1),
    discountPeriodWeekend: Array(48).fill(1),
    discountPercentageWeekday: Array(48).fill(0),
    discountPercentageWeekend: Array(48).fill(0),
    loiteringSuspensionPeriodWeekday: Array(48).fill(0),
    loiteringSuspensionPeriodWeekend: Array(48).fill(0),
    ignoreChargingFee: false,
    ignoreLoiteringFee: true,
    ignoreConstantFee: false,
    ignoreDemandResponseFee: false,
    ignoreGuestFee: false,
    type: null,
    users: mockDiscountPlanUser,
    listingGroupId: 550,
    appliedListings: [
      {
        listingId: 11,
        listingTitle: 'L6652',
      },
    ],
    creatorName: null,
    createdAt: moment().format(),
    updatedAt: moment().format(),
  },
] as DiscountSchema[]
